import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from '../Button';

var Submit =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Submit, _PureComponent);

  var _super = _createSuper2(Submit);

  function Submit(props) {
    var _this;

    _classCallCheck(this, Submit);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Submit, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this2 = this;

      e.persist();
      setTimeout(function () {
        if (_this2.props.onSubmit) _this2.props.onSubmit(e.target);
      }, 50);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          loading = _this$props.loading,
          children = _this$props.children,
          formStatus = _this$props.formStatus,
          other = _objectWithoutProperties(_this$props, ["onSubmit", "loading", "children", "formStatus"]);

      return (
        /*#__PURE__*/
        React.createElement(Button, Object.assign({
          type: "primary"
        }, other, {
          disabled: other.disabled || formStatus === 'disabled',
          loading: formStatus === 'pending' || loading,
          onClick: this.handleClick
        }), children)
      );
    }
  }]);

  return Submit;
}(PureComponent);

export default Submit;